import Header from "./Header";
import Footer from "./footer";
import { useEffect, useState } from "react";
import { AddAddressUrl, cancelOrder, CityUrl, CountryUrl, image_url, ListAddressUrl, orderListUrl, Post, RemoveAddrUrl, StateUrl, updatePasswordUrl } from "../utils/api";
import Modal from 'react-bootstrap/Modal';
import Button from "../component/Button";
import { Loader } from "../component/Loader2";
import {wrapComponent} from 'react-snackbar-alert';
import { useSelector } from "react-redux";
import TextInput from "../component/TextInput.js";
import { useNavigate } from "react-router-dom";

const Home = ({createSnackbar}) => {
    const navigate = useNavigate();

    const [isLoading,setisLoading] = useState(false);
    const [showAddressMmodal, setshowAddressMmodal] = useState(false);
    const [activeTab,setActiveTab] = useState(2)
    const [addressList,setaddressList] = useState([]);
    const [countryList,setcountryList] = useState([]);
    const [stateList,setstateList] = useState([]);
    const [cityList,setcityList] = useState([]);
    const [orderList,setorderList] = useState([]);
    const {userinfo} = useSelector(state=>state);
    const [password,setPassword] = useState('');
    const [cnfpassword,setcnfpassword] = useState('');
    const [oldpassword,setOldpassword] = useState('');
    const [state,setState] = useState({
        first_name:'',
        last_name:'',
        house_no:'',
        apartment:'',
        pincode:'',
        country:'',
        state:'',
        city:'',
        type:'home',
        address_id:'',
    })

    const stateHandler = (key, value) => {
        state[key] = value;
        setState({ ...state });
    };


    const showSnack = (msg='',type='error') =>{
        createSnackbar({
          message: msg,
          theme: type,
        });
      }
    const deleteAddress = (id) =>{
        global.Loader(true)
        let config = {
            body:{address_id:id},
            url:RemoveAddrUrl,
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                fetchListAddress();
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }



    const submitAddAddress = () =>{
        setisLoading(true)
        let body = {
            first_name:state.first_name,
            last_name:state.last_name,
            house_no:state.house_no,
            apartment:state.apartment,
            pincode:state.pincode,
            country:state.country,
            state:state.state,
            city:state.city,
            address_type:state.type,
        }

        if(state?.address_id) {
            body.address_id = state.address_id
        };
        
        let config = {
            body:body,
            url:AddAddressUrl,
        }
        Post(config).then((res)=>{
            setisLoading(false)
            setshowAddressMmodal(false)
            if(res.status == true) {
                setState({
                    first_name:'',
                    last_name:'',
                    house_no:'',
                    apartment:'',
                    pincode:'',
                    country:'',
                    state:'',
                    city:'',
                    type:'',
                    address_id:''
                });
                fetchListAddress();
                showSnack(res.message,'success');
            }
        }).catch((err)=>{
            setshowAddressMmodal(false)
            setisLoading(false)
            console.log(err?.response?.data);
        })
    }
    useEffect(()=>{
        fetchListAddress()
        fetchCountyList();
        fetchOrderList()
    },[])



  const fetchCountyList = () =>{
    let config = {
        url:CountryUrl,
    }
    Post(config).then((res)=>{
        if(res.status == true) {
            setcountryList(res?.data)
        }
    }).catch((err)=>{
      console.log(err?.response);
    })
  }

  const fetchStateList = (id) =>{
    setisLoading(true)
    let config = {
        body:{country_id:id},
        url:StateUrl,
    }
    Post(config).then((res)=>{
        setisLoading(false)
        if(res.status == true) {
            setstateList(res?.data)
        }
    }).catch((err)=>{
      setisLoading(false)
      console.log(err?.response?.data);
    })
  }

  const fetchCityList = (id) =>{
    setisLoading(true)
    let config = {
        body:{state_id:id},
        url:CityUrl,
    }
    Post(config).then((res)=>{
        setisLoading(false)
        if(res.status == true) {
            setcityList(res?.data)
        }
    }).catch((err)=>{
      setisLoading(false)
      console.log(err?.response?.data);
    })
  }

    const fetchListAddress = () =>{
        global.Loader(true)
        let config = {
            url:ListAddressUrl,
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                setaddressList(res.data);
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }


    const fetchOrderList = () =>{
        global.Loader(true)
        let config = {
            url:orderListUrl,
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                setorderList(res.data);
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }


    const updatePassword = () =>{
        if(oldpassword == '') {
            showSnack('Please Enter Old Password!');
        } else if(password == '') {
            showSnack('Please Enter Password!');
        } else if(password != cnfpassword) {
            showSnack('Confirm Password Not Matched!');
        } else {
            
            global.Loader(true)
            let config = {
                body:{
                    password:password,
                    confirm_password:cnfpassword,
                    old_password:oldpassword
                },
                url:updatePasswordUrl,
            }
            
            Post(config).then((res)=>{
                global.Loader(false)
                if(res.status == true) {
                    showSnack(res.message,'success');
                } else {
                    showSnack(res.message);
                }
            }).catch((err)=>{
                global.Loader(false)
                console.log(err?.response?.data);
            })
        }
    }

    const cancelOrderApi = (id) =>{
        global.Loader(true)
        let config = {
            body:{
                order_id:id
            },
            url:cancelOrder,
        }
        
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                showSnack(res.message,'success');
                fetchOrderList();
            } else {
                showSnack(res.message);
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }
    
    
    const renderChangePassowrd = () =>(
        <div id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
            <div className="point1">
                <div className="container">
                    <div className="row" style={{marginTop:'100px'}}>
                        <div className="recent">
                            <h4>Change Password</h4>
                        </div>
                        <div style={{marginTop:'30px'}}>
                            <TextInput mainStyle={{paddingLeft:'0px'}} value={oldpassword} type="text"  onChange={setOldpassword} placeholder="Enter Old Password" />
                            <TextInput mainStyle={{paddingLeft:'0px'}} value={password} type="text"  onChange={setPassword} placeholder="Enter Password" />
                            <TextInput mainStyle={{paddingLeft:'0px'}} value={cnfpassword} type="password"  onChange={setcnfpassword} placeholder="Enter Confirm Password" />
                        </div>
                        <div className='row' style={{justifyContent:'center'}}>
                            <Button backgroundColor={'#219653'} onClick={()=>{
                                updatePassword()
                            }} style={{width:'80%'}} title={'Change Password'} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
    const renderAddress = () => (
        <div id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">
            <div className="Addresses">
                <div className="container">
                    <div className="row" style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <div style={{display:'flex',marginTop:'100px',marginBottom:'20px',flexDirection:'row',justifyContent:'space-between'}}>
                            <h2 className="today">Addresses</h2>
                            <button onClick={()=>{
                                setshowAddressMmodal(true);
                            }} style={{
                                background: 'linear-gradient(92.5deg, #EDF8FF 14.05%, #E4F4FF 115.05%)',
                                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.4)',
                                borderRadius: '30px',
                                border: 'none',
                                padding: '5px 10px',
                                fontFamily: 'Montserrat',
                                fontStyle: 'normal',
                                fontWeight: '500',
                                fontSize: '16px',
                                alignItems: 'center',
                                color: 'rgba(0, 0, 0, 0.7)',
                            }}>+ Add Address</button>
                        </div>
                            
                        {addressList?.map((v,i)=>(
                            <div className="addr" style={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: '1',
                                width: '545px',
                                marginBottom:'40px'
                            }}>
                                <div className="addres" style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                                    <h3>{v.address_type}</h3>
                                    {(v.default)&&<h3><span>Saved as default</span></h3>}
                                </div>
                                <div className="text">
                                    <p>#{v.house_no}, {v.first_name} {v.last_name}, {v.apartment}, {v.city_name}, {v.state_name}, {v.country_name} - {v.pincode}</p>
                                </div>
                                <div className="edit">
                                    <button onClick={()=>{
                                        setState({
                                            first_name:v?.first_name,
                                            last_name:v?.last_name,
                                            house_no:v?.house_no,
                                            apartment:v?.apartment,
                                            pincode:v?.pincode,
                                            country:v?.country_id,
                                            state:v?.state_id,
                                            city:v?.city_id,
                                            type:v?.address_type,
                                            address_id:v?.id
                                        });
                                        fetchCityList(v?.state_id);
                                        fetchStateList(v?.country_id);  
                                        setshowAddressMmodal(true)
                                    }} className="abcd1">edit</button>
                                    <button onClick={()=>{
                                        deleteAddress(v.id);
                                    }} className="abcd2">remove</button>
                                </div>
                            </div>
                        ))}
                        
                        {/* <div className="col-md-6">
                            <h2 className="today">Addresses</h2>
                            <div className="addnew add_now">
                                <a href="#"><i className="fa-solid fa-plus"></i> Add New</a>
                            </div>
                            
                        </div>
                        <div className="col-md-6">
                            <div className="addnew">
                                <a href="#"><i className="fa-solid fa-plus"></i> Add New</a>
                            </div>
                            
                            <div className="addr1">
                                <div className="addres">
                                    <h3>Home</h3>
                                </div>
                                <div className="text">
                                    <p>#1234, Abcd Society, xyz Marg, IT city,<br/> Chandigarh, Chandigarh, India. - 160023</p>
                                </div>
                                <div className="edit">
                                    <button className="abcd1">edit</button>
                                    <button className="abcd2">remove</button>
                                    <button className="abcd3">set as default</button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            {renderAddAddressModal()}
        </div>
    )

    const renderAddAddressModal = () =>(
        <Modal show={showAddressMmodal} onHide={()=>{
            setState({
                first_name:'',
                last_name:'',
                house_no:'',
                apartment:'',
                pincode:'',
                country:'',
                state:'',
                city:'',
                type:'',
                address_id:''
            });
            setshowAddressMmodal(false)
            }}>
            <Loader isLoading={isLoading} />
            <Modal.Header closeButton>
            <Modal.Title>Add Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input value={state.first_name} type={'text'} onChange={({target})=>{
                    stateHandler('first_name',target.value)
                }} placeholder="First Name"  style={{...styles.input}} />
                <input value={state.last_name} type={'text'} onChange={({target})=>{
                    stateHandler('last_name',target.value)
                }} placeholder="Last Name"  style={{...styles.input}} />
                <input value={state.house_no} type={'number'} onChange={({target})=>{
                    stateHandler('house_no',target.value)
                }} placeholder="House No"  style={{...styles.input}} />
                <input value={state.apartment} type={'text'} onChange={({target})=>{
                    stateHandler('apartment',target.value)
                }} placeholder="Apartment"  style={{...styles.input}} />
                <input value={state.pincode} type={'number'} onChange={({target})=>{
                    stateHandler('pincode',target.value)
                }} placeholder="Pincode"  style={{...styles.input}} />
                <select value={state.country} onChange={({target})=>{
                    stateHandler('country',target.value)
                    fetchStateList(target.value)
                }} style={styles.input}>
                    <option value={''}>Select Country</option>
                    {countryList?.map((v)=><option value={v.id}>{v.name}</option>)}
                </select>
                <select value={state.state} onChange={({target})=>{
                    stateHandler('state',target.value)
                    fetchCityList(target.value)
                }} style={styles.input}>
                    <option value={''}>Select State</option>
                    {stateList?.map((v)=><option value={v.id}>{v.name}</option>)}
                </select>
                <select value={state.city} onChange={({target})=>{
                    stateHandler('city',target.value);
                }}  style={styles.input}>
                    <option value={''}>Select City</option>
                    {cityList?.map((v)=><option value={v.id}>{v.city}</option>)}
                </select>
                
                <div className="row" style={{marginLeft:'20px'}}>
                    <div className="col-md-3">
                        <input value={state.type} onChange={({target})=>{
                            stateHandler('type',target.value)
                        }} type="radio" checked id="home" name="type" value="home" />
                        <label style={{marginLeft:'10px'}} for="home"> Home</label><br/>
                    </div>
                    <div className="col-md-3">
                        <input value={state.type} onChange={({target})=>{
                            stateHandler('type',target.value)
                        }}  type="radio" id="work" name="type" value="work" />
                        <label style={{marginLeft:'10px'}} for="work"> Work</label><br/>
                    </div>
                </div>
                <div style={{display:'flex',marginTop:'40px',marginBottom:'20px',alignItems:'center',justifyContent:'center'}}>
                    <Button onClick={()=>{
                        submitAddAddress()
                    }} disable={(state.first_name=='' || state.last_name=='' || state.house_no=='' || state.apartment=='' || state.pincode=='' || state.country=='' || state.state=='' || state.city=='')} backgroundColor={'#219653'} title={'Submit'} />
                </div>
            </Modal.Body>
        </Modal>
    )
    const renderOrders = () =>(
            <div id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                <div className="point1">
                    <div className="container">
                        <div className="row" style={{marginTop:'100px'}}>
                            <div className="recent">
                                <h4>{(activeTab==2)?'Overview':'My Orders'}</h4>
                            </div>
                            {orderList?.map((v,i)=>(
                                (v.order_status != 'cancel')&&
                                <div className="spaces">
                                    <div className="accordion_order">
                                        <div className="accordion accordion-flush" id="accordionFlushExample">
                                            <div className="accordion-item1">
                                                <div className="orders_status" style={{height:'240px'}}>
                                                    <div className="order_price">
                                                        <h3>Order #{v.order_id} <span>₹{v.paid_total}</span></h3>
                                                        <p>Ordered on {v.order_date}</p>
                                                    </div>
                                                    <div className="dispaching">
                                                        <p>Status: {v.order_status}</p>
                                                        <p>You should recive your order by 25th Nov.</p>
                                                        <p>{v.address}</p>
                                                    </div>
                                                    <div className="auto_layout">
                                                        <p>Track Order</p>
                                                    </div>
                                                    <div onClick={()=>{
                                                        cancelOrderApi(v.order_id)
                                                    }} className="auto_layout" style={{marginTop:'20px',color:'#FFFFFF',background:'red'}}>
                                                        <p style={{color:'#ffffff'}}>Cancel Order</p>
                                                    </div>
                                                </div>
                                                <h2 className="accordion-header" id="flush-headingOne">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOne${i}`} aria-expanded="false" aria-controls="flush-collapseOne">
                                                    Order Contents ({v?.order_detail?.length})
                                                </button>
                                                </h2>
                                                <div id={`flush-collapseOne${i}`} className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                <div className="accordion-body1">
                                                    {v?.order_detail?.map((v2,i)=>(
                                                        <div className="grey">
                                                            {/* <img src="/images/Active-women.png" alt=""/> */}
                                                            <img src={`${image_url}${v2?.image}`} alt="" style={{height:'50px',width:'37px',marginRight:'25px'}}/>
                                                            <div className="kids1">
                                                                <h2>{truncate(v2.product_name)}</h2>
                                                                <p>Qty. - {v2.quantity}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            
                        </div>
                        {/* <div className="back5">
                            <ul className="pager1">
                                <li><a href="#" className="back9"><i className="fa-solid fa-angle-left"></i> Back</a></li>
                                <li><a href="#" className="back8">1</a></li>
                                <li><a href="#" className="back7">2</a></li>
                                <li><a href="#" className="back6">3</a></li>
                                <li><a href="#" className="next">Next <i className="fa-solid fa-angle-right"></i></a></li>
                            </ul>
                        </div> */}
                    </div>
                </div>
                </div>
                
    )
    

const truncate = (value) =>{
    if(value) {
        return `${value.substr(0,20)}...`;
    } else {
        return '';
    }
  }
    return (
      <div>
      <Header />
        <section>
            <div className="container">
                <div className="banner">
                    <img src="/images/Rectangle.jpg" alt="" />
                </div>
            </div>
        </section>
      <section>
        <div className="container">
            <div className="welcome">
                <div className="mizuki services">
                    <span className="ipsum"><i className="fa-solid fa-ellipsis-vertical"></i></span>
                    <h1>My Account</h1>
                    <span className="ipsum1"><i className="fa-sharp fa-solid fa-xmark"></i></span>
                  </div>
                <div className="logo1">
                    <img src="/images/bs.png" alt=""/>
                    <div className="sanu">
                        <p>Welcome</p>
                        <h2>Bindu Shah</h2>
                    </div>
                </div>
                {/* <div className="menu_color">
                    <p>Your Last order is about to exhaust in 5 days.</p>
                    <button>Reorder</button>
                </div> */}
                <div className="d-flex align-items-start">
                    <div className="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      {/* <button onClick={()=>{
                        setActiveTab(1)
                      }} className="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true"><i className="fa-regular fa-bell"></i> <span>Notifications</span></button> */}
                      <button onClick={()=>{
                        setActiveTab(2)
                      }} className="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false"><i className="fa-solid fa-qrcode"></i> <span>Overview</span></button>
                      <button onClick={()=>{
                        setActiveTab(3)
                      }} className="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false"><i className="fa-regular fa-clock"></i> <span>My Orders</span></button>
                      <button onClick={()=>{
                        setActiveTab(4)
                      }} className="nav-link" id="v-pills-settings-tab" data-bs-toggle="pill" data-bs-target="#v-pills-settings" type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false"><i className="fa-solid fa-location-dot"></i> <span>Addresses</span> </button>
                      <button onClick={()=>{
                        setActiveTab(5)
                      }} className="nav-link" id="v-pills-settings-tab1" data-bs-toggle="pill" data-bs-target="#v-pills-settings1" type="button" role="tab" aria-controls="v-pills-settings1" aria-selected="false"><i className="fa-sharp fa-solid fa-credit-card"></i> <span>Payment Methods</span></button>
                      <button onClick={()=>{
                        setActiveTab(6)
                      }} className="nav-link" id="v-pills-settings-tab2" data-bs-toggle="pill" data-bs-target="#v-pills-settings2" type="button" role="tab" aria-controls="v-pills-settings2" aria-selected="false"><i className="fa-solid fa-lock"></i> <span>Change Password</span></button>
                      <button onClick={()=>{
                        setActiveTab(7)
                      }} className="nav-link" id="v-pills-settings-tab3" data-bs-toggle="pill" data-bs-target="#v-pills-settings3" type="button" role="tab" aria-controls="v-pills-settings3" aria-selected="false"><i className="fa-solid fa-bell"></i> <span>Need help?</span></button>
                      <button onClick={()=>{
                        global.dispatch({
                            type:'LOGOUT',
                        });
                        navigate('/');
                      }} className="nav-link" id="v-pills-settings-tab4" data-bs-toggle="pill" data-bs-target="#v-pills-settings4" type="button" role="tab" aria-controls="v-pills-settings4" aria-selected="false"><i className="fa-solid fa-right-from-bracket"></i> <span>Logout</span></button>
                    </div>
                    <div className="tab-content" id="v-pills-tabContent">
                      {/* <div className="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">1</div> */}
                      {/* <div id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                        <div className="point">
                            <div className="container">
                                <div className="row">
                                    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-indicators">
                                          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                          <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                        </div>
                                        <div className="carousel-inner">
                                            <div className="save">
                                                <h2>Saved Addresses</h2>
                                            </div>
                                          <div className="carousel-item active">
                                            <div className="saved1">
                                                <div className="save1"> 
                                                    <h3>home</h3>   
                                                    <p>Saved as default</p>
                                                </div>
                                                <p>#1234, Abcd Society, xyz Marg, IT city, Chandigarh, Chandigarh, Chandigarh Road, India. - 160023</p>
                                            </div>
                                          </div>
                                          <div className="carousel-item">
                                            <div className="saved1">
                                                <div className="save1"> 
                                                    <h3>home</h3>   
                                                </div>
                                                <p>#1234, Abcd Society, xyz Marg, IT city, Chandigarh, Chandigarh, Chandigarh Road, India. - 160023</p>
                                            </div>
                                          </div>
                                          <div className="carousel-item">
                                            <div className="saved1">
                                                <div className="save1"> 
                                                    <h3>home</h3>   
                                                </div>
                                                <p>#1234, Abcd Society, xyz Marg, IT city, Chandigarh, Chandigarh, Chandigarh Road, India. - 160023</p>
                                            </div>
                                          </div>
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                                          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                          <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                                          <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                          <span className="visually-hidden">Next</span>
                                        </button>
                                      </div>
                                    <div className="spaces">
                                        <div className="recent">
                                            <h4>Recent Orders</h4>
                                            <span><a href="#">View all</a></span>
                                        </div>
                                        <div className="accordion_order">
                                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                                <div className="accordion-item1">
                                                    <div className="orders_status">
                                                        <div className="order_price">
                                                            <h3>Order #00000 <span>₹2,199</span></h3>
                                                            <p>Ordered on 15th July 2022</p>
                                                        </div>
                                                        <div className="dispaching">
                                                            <p>Status: Dispaching</p>
                                                            <p>You should recive your order by 25th Nov.</p>
                                                        </div>
                                                        <div className="auto_layout">
                                                            <p>Track Order</p>
                                                        </div>
                                                    </div>
                                                  <h2 className="accordion-header" id="flush-headingOne">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                        Order Contents (3)
                                                    </button>
                                                  </h2>
                                                  <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                    <div className="accordion-body1">
                                                        <div className="grey">
                                                            <img src="/images/Active-women (1).png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women (1).png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women (1).png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="spaces">
                                        <div className="accordion_order">
                                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                                <div className="accordion-item1">
                                                    <div className="orders_status">
                                                        <div className="order_price">
                                                            <h3>Order #00000 <span>₹2,199</span></h3>
                                                            <p>Ordered on 15th July 2022</p>
                                                        </div>
                                                        <div className="dispaching">
                                                            <p>Status: Dispaching</p>
                                                            <p>You should recive your order by 25th Nov.</p>
                                                        </div>
                                                        <div className="auto_layout">
                                                            <p>Track Order</p>
                                                        </div>
                                                    </div>
                                                  <h2 className="accordion-header" id="flush-headingTwo">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                                        Order Contents (3)
                                                    </button>
                                                  </h2>
                                                  <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                    <div className="accordion-body1">
                                                        <div className="grey">
                                                            <img src="/images/Active-women (1).png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women (1).png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women (1).png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="spaces">
                                        <div className="accordion_order">
                                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                                <div className="accordion-item1">
                                                    <div className="orders_status">
                                                        <div className="order_price">
                                                            <h3>Order #00000 <span>₹2,199</span></h3>
                                                            <p>Ordered on 15th July 2022</p>
                                                        </div>
                                                        <div className="dispaching">
                                                            <p>Status: Dispaching</p>
                                                            <p>You should recive your order by 25th Nov.</p>
                                                        </div>
                                                        <div className="auto_layout">
                                                            <p>Track Order</p>
                                                        </div>
                                                    </div>
                                                  <h2 className="accordion-header" id="flush-headingTwo">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                                        Order Contents (3)
                                                    </button>
                                                  </h2>
                                                  <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                                                    <div className="accordion-body1">
                                                        <div className="grey">
                                                            <img src="/images/Active-women (1).png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women (1).png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women (1).png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="point2">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="save">
                                            <h2>Saved Addresses</h2>
                                        </div>
                                        <div className="saved1">
                                            <div className="save1"> 
                                                <h3>home</h3>   
                                                <p>Saved as default</p>
                                            </div>
                                            <p>#1234, Abcd Society, xyz Marg, IT city, Chandigarh, Chandigarh, Chandigarh Road, India. - 160023</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="view_all">
                                            <a href="#">View all</a>
                                        </div>
                                        <div className="nana">
                                            <div className="nanaji">
                                                <h3>nana ji</h3>
                                                <p>#1234, Abcd Society, xyz Marg, IT city, Chandigarh, Chandigarh, Chandigarh Road, India. - 160023</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="spaces">
                                        <div className="recent">
                                            <h4>Recent Orders</h4>
                                            <span><a href="#">View all</a></span>
                                        </div>
                                        <div className="accordion_order">
                                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                                <div className="accordion-item1">
                                                    <div className="orders_status">
                                                        <div className="order_price">
                                                            <h3>Order #00000 <span>₹2,199</span></h3>
                                                            <p>Ordered on 15th July 2022</p>
                                                        </div>
                                                        <div className="dispaching">
                                                            <p>Status: Dispaching</p>
                                                            <p>You should recive your order by 25th Nov.</p>
                                                        </div>
                                                        <div className="auto_layout">
                                                            <p>Track Order</p>
                                                        </div>
                                                    </div>
                                                  <h2 className="accordion-header" id="flush-headingOne">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                        Order Contents (3)
                                                    </button>
                                                  </h2>
                                                  <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                    <div className="accordion-body1">
                                                        <div className="grey">
                                                            <img src="/images/Active-women.png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women.png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women.png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="spaces">
                                        <div className="accordion_order">
                                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                                <div className="accordion-item1">
                                                    <div className="orders_status">
                                                        <div className="order_price">
                                                            <h3>Order #00000 <span>₹2,199</span></h3>
                                                            <p>Ordered on 15th July 2022</p>
                                                        </div>
                                                        <div className="dispaching">
                                                            <p>Status: Dispaching</p>
                                                            <p>You should recive your order by 25th Nov.</p>
                                                        </div>
                                                        <div className="auto_layout">
                                                            <p>Track Order</p>
                                                        </div>
                                                    </div>
                                                  <h2 className="accordion-header" id="flush-headingTwo">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                                        Order Contents (3)
                                                    </button>
                                                  </h2>
                                                  <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                    <div className="accordion-body1">
                                                        <div className="grey">
                                                            <img src="/images/Active-women.png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women.png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women.png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="spaces">
                                        <div className="accordion_order">
                                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                                <div className="accordion-item1">
                                                    <div className="orders_status">
                                                        <div className="order_price">
                                                            <h3>Order #00000 <span>₹2,199</span></h3>
                                                            <p>Ordered on 15th July 2022</p>
                                                        </div>
                                                        <div className="dispaching">
                                                            <p>Status: Dispaching</p>
                                                            <p>You should recive your order by 25th Nov.</p>
                                                        </div>
                                                        <div className="auto_layout">
                                                            <p>Track Order</p>
                                                        </div>
                                                    </div>
                                                  <h2 className="accordion-header" id="flush-headingTwo">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                                        Order Contents (3)
                                                    </button>
                                                  </h2>
                                                  <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                                                    <div className="accordion-body1">
                                                        <div className="grey">
                                                            <img src="/images/Active-women.png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women.png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                        <div className="grey">
                                                            <img src="/images/Active-women.png" alt=""/>
                                                            <div className="kids1">
                                                                <h2>Kids Pride Chocolate | 200g</h2>
                                                                <p>Qty. - 1</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div> */}
                      {(activeTab==3 || activeTab==2)&&renderOrders()}
                      {(activeTab==4)&&renderAddress()}
                      {(activeTab==6)&&renderChangePassowrd()}
                      {/* <div id="v-pills-settings1" role="tabpanel" aria-labelledby="v-pills-settings-tab1">
                        <div className="payment">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h2 className="today">Payment Methods</h2>
                                        <div className="addnew add_now">
                                            <a href="#"><i className="fa-solid fa-plus"></i> Add New</a>
                                        </div>
                                        <div className="addr5">
                                            <div className="addres">
                                                <h3>Bindu Shahhhhhhhh... <span>Saved as default</span></h3>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="visa">
                                                        <p>VISA Debit (1212) <br/>Exp: 02/22</p>
                                                        
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="debit">
                                                        <img src="/images/visa.png" alt=""/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="edit">
                                                <button className="abcd1">edit</button>
                                                <button className="abcd2">remove</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="addnew1">
                                            <a href="#"><i className="fa-solid fa-plus"></i> Add New</a>
                                        </div>
                                        <div className="addr6">
                                            <div className="addres">
                                                <h3>Bindu Shah</h3>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="visa">
                                                        <p>VISA Debit (1212) <br/>Exp: 02/22</p>
                                                        
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="debit">
                                                        <img src="/images/visa.png" alt=""/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="edit">
                                                <button className="abcd1">edit</button>
                                                <button className="abcd2">remove</button>
                                                <button className="abcd2">set as default</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="addr5">
                                            <div className="addres">
                                                <h3>Bindu Shah</h3>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="visa">
                                                        <p>VISA Debit (1212) <br/>Exp: 02/22</p>
                                                        
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="debit">
                                                        <img src="/images/mastercard.png" alt=""/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="edit">
                                                <button className="abcd1">edit</button>
                                                <button className="abcd2">remove</button>
                                                <button className="abcd2">set as default</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="addr6">
                                            <div className="addres">
                                                <h3>Bindu Shah</h3>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="visa">
                                                        <p>VISA Debit (1212) <br/>Exp: 02/22</p>
                                                        
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="debit">
                                                        <img src="/images/visa.png" alt=""/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="edit">
                                                <button className="abcd1">edit</button>
                                                <button className="abcd2">remove</button>
                                                <button className="abcd2">set as default</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="addr5">
                                            <div className="addres">
                                                <h3>Bindu Shah</h3>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="visa">
                                                        <p>VISA Debit (1212) <br/>Exp: 02/22</p>
                                                        
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="debit">
                                                        <img src="/images/visa.png" alt=""/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="edit">
                                                <button className="abcd1">edit</button>
                                                <button className="abcd2">remove</button>
                                                <button className="abcd2">set as default</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                      <div id="v-pills-settings2" role="tabpanel" aria-labelledby="v-pills-settings-tab2">6</div>
                      <div id="v-pills-settings3" role="tabpanel" aria-labelledby="v-pills-settings-tab3">7</div>
                      <div id="v-pills-settings4" role="tabpanel" aria-labelledby="v-pills-settings-tab4">8</div> */}
                    </div>
                </div>
            </div>
            
        </div>
    </section>
    </div>
    );
  };
  
export default wrapComponent(Home);


const styles = {
    input:{
      fontFamily:'Montserrat',
      borderWidth:0,
      textAlign:'left',
      backgroundColor:'#CCDDFF',
      width:410,
      height:50,
      borderRadius:10,
      marginBottom:15,
      paddingLeft:20,
      marginLeft:30
    }
  }